import { render, staticRenderFns } from "./StudentDiscipline.vue?vue&type=template&id=79c0154c&"
import script from "./StudentDiscipline.vue?vue&type=script&lang=js&"
export * from "./StudentDiscipline.vue?vue&type=script&lang=js&"
import style0 from "./StudentDiscipline.vue?vue&type=style&index=0&id=79c0154c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports